import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import NewMessageHeader from './new_message_header/NewMessageHeader';
import NewMessageBox from './new_message_box/NewMessageBox';

{/* User avatar and markdown box to create new Client Messages   */}
const CorrespondanceNewMessage = (props) => {
  const {
    // props for NewMessageHeader
    clientData,
    corType,
    setCorType,
    sortDir,
    setSortDir,

    // props for NewMessageBox
    clientRn,
    clientBackend,
    messageMode,
    setMessageMode,
    messageRecipientRn,
    setMessageRecipientRn,
    replyDraft,
  } = props;

  const messageRecipient = clientData.relationships[messageRecipientRn] || null;

  return (
    <Stack
      id={`messageHeader-${clientRn}`}
      sx={{
        gap: 1,
        py: 1,
        px: {md: 2, xs: 1},
      }}
    >
      <NewMessageHeader
        corType={corType}
        setCorType={setCorType}
        sortDir={sortDir}
        setSortDir={setSortDir}
        clientData={clientData}
        messageMode={messageMode}
        setMessageMode={setMessageMode}
        messageRecipientRn={messageRecipientRn}
        setMessageRecipientRn={setMessageRecipientRn}
      />
      <NewMessageBox
        clientRn={clientRn}
        clientBackend={clientBackend}
        messageMode={messageMode}
        messageRecipient={messageRecipient}
        replyDraft={replyDraft}
      />
    </Stack>
  );
};
CorrespondanceNewMessage.propTypes = {
  // props for NewMessageHeader
  corType: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
    LOGS: PropTypes.bool.isRequired,
    CALENDLY_UPDATE: PropTypes.bool.isRequired,
    DIALPAD_SMS_TEXT: PropTypes.bool.isRequired,
    DIALPAD_CALL_TRANSCRIPT: PropTypes.bool.isRequired,
    EMAIL: PropTypes.bool.isRequired,
  }).isRequired,
  setCorType: PropTypes.func.isRequired,
  sortDir: PropTypes.string.isRequired,
  setSortDir: PropTypes.func.isRequired,

  // props for NewMessageBox
  clientRn: PropTypes.string.isRequired,
  clientBackend: PropTypes.object.isRequired,
  clientData: PropTypes.shape({
    relationships: PropTypes.object,
  }).isRequired,
  messageMode: PropTypes.string.isRequired,
  setMessageMode: PropTypes.func.isRequired,
  messageRecipientRn: PropTypes.string.isRequired,
  setMessageRecipientRn: PropTypes.func.isRequired,
  replyDraft: PropTypes.shape({
    inReplyTo: PropTypes.string.isRequired,
    quotedHtml: PropTypes.string.isRequired,
    quotedText: PropTypes.string.isRequired,
    references: PropTypes.arrayOf(PropTypes.string).isRequired,
    replyHeader: PropTypes.string.isRequired,
    relationshipRn: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
  }),
};

export default React.memo(CorrespondanceNewMessage);
